import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatSelect } from '@angular/material';

interface Item {
  id: number;
  name?: string;
}

@Component({
  selector: 'ml-select',
  template: `
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ label | translate | titlecase }}</mat-label>
      <mat-icon *ngIf="prefixIcon" [svgIcon]="prefixIcon" matPrefix></mat-icon>

      <mat-select [formControl]="control" [multiple]="multiple">
        <div *ngIf="filterable" class="filter filter--sticky" fxLayout="row">
          <mat-icon
            matPrefix
            class="filter--margin"
            svgIcon="search"
          ></mat-icon>
          <input
            matInput
            placeholder="{{ 'filter' | translate | titlecase }}"
            type="text"
            autocomplete="off"
            [formControl]="filterControl"
            (keydown.Space)="$event.stopPropagation()"
          />
        </div>
        <button
          *ngIf="control.value && clear"
          (click)="onClear()"
          mat-button
          class="filter__clear"
        >
          {{ 'clear' | translate | uppercase }}
        </button>
        <mat-option
          *ngFor="let item of (filteredItems | async)"
          [value]="item.id"
        >
          <span *ngIf="translate"> {{ displayFn(item) | translate }} </span>
          <span *ngIf="!translate"> {{ displayFn(item) }} </span>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="control.hasError('required')">
        {{ label | translate | titlecase }} {{ 'is-required' | translate }}
      </mat-error>
    </mat-form-field>
  `,
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {
  filterControl: FormControl = new FormControl();
  filteredItems: Observable<Item[]>;
  options: Item[];
  @ViewChild(MatSelect, { static: true }) matSelect: MatSelect;

  @Output() select = new EventEmitter();

  @Input('options') set items(options: any[]) {
    if (options) {
      this.initFilter();
      this.options = options;
    }
  }

  @Input() prefixIcon: string;
  @Input() label: string;
  @Input() translate = false;
  @Input() filterable = true;
  @Input() clear = true;
  @Input() multiple: boolean;
  @Input() control: FormControl;
  @Input() displayFn = item => item.name;

  constructor() {}

  ngOnInit() {
    this.control.valueChanges.subscribe(value => {
      this.select.emit(value);
    });
  }

  onClear() {
    this.control.setValue(null);
    this.matSelect.close();
  }

  initFilter() {
    this.filteredItems = this.filterControl.valueChanges.pipe(
      startWith(''),
      map(filterBy =>
        filterBy ? this.filteredBy(filterBy) : this.options.slice()
      )
    );
  }

  filteredBy(filterBy: string) {
    if (!this.options) {
      return [];
    }

    return this.options.filter(
      item =>
        this.displayFn(item)
          .toLowerCase()
          .indexOf(filterBy.toLowerCase()) > -1
    );
  }
}
